import styled from 'styled-components';

export const LinkBlob = styled.span`
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(
    ${props => props.theme.yoga.spacing.zero}px
      ${props => props.theme.yoga.spacing.zero}px 99.9% 99.9%
  );
  overflow: hidden;
  height: 1px;
  width: 1px;
  padding: ${props => props.theme.yoga.spacing.zero};
  border: ${props => props.theme.yoga.spacing.zero};
  top: 50%;
`;
